import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { consentCancelModalData } from '../../data/modalContentData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import Headings from '../../components/Headings'
import InformationCard from '../../components/InformationCard'
import PageFooter from '../../components/PageFooter'
import PageModal from '../../components/PageModal'
import DirectionLink from '../../components/DirectionLink'
import DataDeletion from './DataDeletion'
import {
  DataHandlingInformationCard,
  ManageShareInformationCard,
} from '../../data/pageInfoCardData'
import { consentFixedFooterContent } from '../../data/footerData'
const ShareData = () => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)
  const [dataDeletionBtnFocused, setDataDeletionBtnFocused] = useState(false)

  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
  }, [navModalBtnFocused])
  function closeModal() {
    setOpenModal(false)
    setNavModalBtnFocused(true)
  }
  function closeDataDeletionPage() {
    setOpenDeletionPage(false)
    setDataDeletionBtnFocused(true)
  }

  /**********************************************************************************************************
  bugfix: for data-deletion page return to share-data page (refresh) which will purge the context 
  when we have real backend or database to store the state, we can change deletion-page to a independent page
  */
  const [openDeletionPage, setOpenDeletionPage] = useState(false)
  // if (openDeletionPage) {
  //   return <DataDeletion onCloseFunc={() => setOpenDeletionPage(false)} />
  // }
  function onClickFuc() {
    setOpenDeletionPage(true)
    setDataDeletionBtnFocused(false)
  }
  const DataHandlingInformationCardData = DataHandlingInformationCard(
    onClickFuc,
    dataDeletionBtnFocused
  )
  /**********************************************************************************************************/
  const pageModalData = {
    isOpen: openModal,
    onClose: () => closeModal(),
    data: {
      ...consentCancelModalData,
      leftButton: 'No',
      leftButtonFunc: () => closeModal(),
      rightButton: 'Yes',
      rightButtonFunc: () => navigate('/cancel-alert'),
      isModalBtn: false,
    },
  }

  const footerData = {
    ...consentFixedFooterContent,
    leftButton: 'Deny',
    leftButtonFunc: () => setOpenModal(!openModal),
    navModalBtnFocused: navModalBtnFocused,
    rightButton: 'Consent',
    rightButtonFunc: () => navigate('/consent-loading'),
    leftButtonLabel:
      'Deny button, to open the cancel process modal double click here',
    rightButtonLabel:
      'Consent button, to consent data sharing and navigate to next page double click here',
  }

  return (
    <>
      <PageWrapper
        isModalOpen={pageModalData.isOpen}
        isDisplay={!openDeletionPage}
      >
        <Helmet>
          <title>Consent to share data</title>
        </Helmet>
        <PageContentWrapper isModalOpen={pageModalData.isOpen}>
          <DirectionLink
            direction="left"
            link="/access-period"
            text="Back"
            isDepenednt={true}
            isFocused={true}
            description="Back button, to visit previous page double click here."
          ></DirectionLink>
          <Headings level="h1" text="Consent to share data"></Headings>
          <p>Key things to know before you consent.</p>
          <InformationCard {...ManageShareInformationCard} />
          <InformationCard {...DataHandlingInformationCardData} />
        </PageContentWrapper>
        <PageFooter {...footerData} />
        <PageModal {...pageModalData} />
      </PageWrapper>
      <DataDeletion
        onCloseFunc={() => closeDataDeletionPage()}
        isDisplay={openDeletionPage}
      />
    </>
  )
}

export default ShareData
